import Image from "next/image";
import Link from "next/link";
import React from "react";
import ShareViaPanel from "../ShareViaPanel";

const BlogDetailsAuthor = ({
  getInitials,
  blog,
  setIsShareOpen,
  setCopyMessage,
  socialEntries,
  isShareOpen,
  shareMobileWrapRef,
  canonicalUrl,
  shareDisplayUrl,
  handleCopyUrl,
  handleShareChannel,
  copyMessage,
}) => {
  const [displayUrl, setDisplayUrl] = React.useState("");

  React.useEffect(() => {
    setDisplayUrl(
      shareDisplayUrl ||
      canonicalUrl ||
      (typeof window !== "undefined" ? window.location.href : "")
    );
  }, [shareDisplayUrl, canonicalUrl]);

  return (
    <>
      <div className="ta-desktop-home-container pt-5 pb-2 bg-white">
        <div className="flex items-start justify-between gap-1.5 md:gap-3">
          <div className="flex items-center gap-1.5 md:gap-3 min-w-0 flex-1">
            <div className="w-8 h-8 lg:h-11 lg:w-11 shrink-0 rounded-full bg-[#EDEDED] flex items-center justify-center text-sm font-semibold text-black">
              {getInitials(blog?.author)}
            </div>
            <div className="min-w-0 flex-1">
              <div className="text-base font-bold text-black leading-tight truncate">
                {blog?.author || "Author"}
              </div>
              <div className="mt-0.5 text-xs text-gray-500">
                {blog?.updatedDate ? (
                  <>Last updated {blog.updatedDate}</>
                ) : (
                  <>Published {blog?.date || "—"}</>
                )}
              </div>
            </div>
          </div>
          <button
            type="button"
            onClick={() => {
              setIsShareOpen((v) => !v);
              setCopyMessage("");
            }}
            className="shrink-0 mt-0.5 p-1 cursor-pointer"
            aria-label="Share"
          >
            <Image
              src="/images/share-2.png"
              alt="share"
              width={20}
              height={20}
              className="w-4 h-4 md:w-5 md:h-5"
               
            />
          </button>
          {socialEntries.length ? (
            <div
              className="mt-2 flex items-center gap-1 md:gap-2 flex-wrap"
              aria-label="Writer social links"
            >
              {socialEntries.map((s) => (
                <Link
                  key={s.key}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.label}
                  aria-label={s.label}
                  className="w-5 h-5 md:h-8 md:w-8 rounded-full bg-[#1E2B55] text-white flex items-center justify-center hover:opacity-90"
                >
                  <s.Icon
                    className="w-2.5 h-2.5 md:h-4 md:w-4"
                    aria-hidden="true"
                  />
                </Link>
              ))}
            </div>
          ) : null}
        </div>
      </div>

      {isShareOpen ? (
        <div
          ref={shareMobileWrapRef}
          className="fixed inset-0 z-[180] flex items-end justify-center sm:items-center px-3 pb-3 pt-10 sm:p-6"
          role="dialog"
          aria-modal="true"
          aria-label="Share article"
        >
          <button
            type="button"
            className="absolute inset-0 bg-black/45 cursor-pointer"
            aria-label="Close share"
            onClick={() => {
              setIsShareOpen(false);
              setCopyMessage("");
            }}
          />
          <div className="relative w-full max-w-md rounded-3xl bg-white shadow-2xl shadow-black/30 border border-gray-100 overflow-hidden max-h-[90vh] flex flex-col py-5">
            <ShareViaPanel
              displayUrl={displayUrl}
              onClose={() => {
                setIsShareOpen(false);
                setCopyMessage("");
              }}
              onCopyUrl={handleCopyUrl}
              onShareChannel={handleShareChannel}
              copyMessage={copyMessage}
            />
          </div>
        </div>
      ) : null}
    </>
  );
};

export default BlogDetailsAuthor;
